/**
 * @voltxampere/ui — STM32 Blue Pill variant (Sprint 47.5-2, polish)
 *
 * Polish of Sprint 43-5 STM32F103C8 placeholder. Sprint 47.5 MVP
 * renders as mcu-execution with atmega328p family defaults (AVR
 * subset placeholder until ARM Cortex-M3 ISA Sprint 49+).
 *
 * Reference: WeAct STM32F103C8T6 Blue Pill (LQFP-48).
 * 37 GPIO + 10 ADC channels (12-bit) + 6 PWM + USB-C/mini.
 * Vcc 2.0-3.6 V, fmax 72 MHz, 64 KB Flash / 20 KB SRAM.
 *
 * Engine zero-diff invariant honored — canonical `mcu-execution`.
 * Cortex-M3 ISA emulation Sprint 49+ engine extension.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuStm32BluePill = {
    id: "stm32-blue-pill",
    nameTr: "STM32 Blue Pill (STM32F103C8, ARM Cortex-M3, placeholder)",
    nameEn: "STM32 Blue Pill (STM32F103C8, ARM Cortex-M3, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "STM32F103C8",
    schemaType: "mcu-execution",
    defaultParams: {
        family: "atmega328p",
        clockHz: 72e6,
        flashHex: "",
        instructionsPerTick: 1000,
        vSupply: 3.3,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-stm32-blue-pill.js.map